import React, { useState } from "react";

function ContactUs() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    organization: "",
    jobTitle: "",
    phone: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.lastName || !form.organization || !form.email) {
      alert("Please fill required fields");
      return;
    }

    alert("Message Sent Successfully");

    setForm({
      firstName: "",
      lastName: "",
      organization: "",
      jobTitle: "",
      phone: "",
      email: "",
      message: ""
    });
  };

  return (
    <>
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 text-white py-5 text-center">
        <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
        <p className="text-blue-200 max-w-2xl mx-auto">
          Get in touch with MetaVix Solutions. We're here to answer your questions and help your business grow.
        </p>
      </section>

      <div className="max-w-4xl mx-auto bg-white shadow-lg p-8 rounded my-10">
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={form.firstName}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name *"
            value={form.lastName}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <input
            type="text"
            name="organization"
            placeholder="Organization *"
            value={form.organization}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <input
            type="text"
            name="jobTitle"
            placeholder="Job Title"
            value={form.jobTitle}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <input
            type="email"
            name="email"
            placeholder="Email *"
            value={form.email}
            onChange={handleChange}
            className="border p-3 w-full rounded"
          />

          <textarea
            name="message"
            placeholder="Message"
            value={form.message}
            onChange={handleChange}
            className="border p-3 w-full rounded h-32"
          />

          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </form>
      </div>
    </>
  );
}

export default ContactUs;